/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {animations as Éµb} from './components/tag-input/animations';
export {TagInputAccessor as Éµa} from './core/accessor';
export {HighlightPipe as Éµd} from './core/pipes/highlight.pipe';
export {DragProvider as Éµc} from './core/providers/drag-provider';